
export interface Parts {
    id?: string;
    type?: string;
}

/**
 * Gets the parts from an MPA name ARN
 * @param name the ARN to parse
 */
export function getParts(name: string): Parts {
    const parts = name.split(':');
    return {
        id: parts[2],
        type: parts[1],
    };
}

/**
 * Makes an MPA name ARN from the type and id
 * @param type the type in the ARN
 * @param id the id of the resource in the ARN
 */
export function makeName(type: string, id: string): string {
    return `aws-proserve:${type}:${id}`;
}

// The default prefix for an MPA portfolio ARN
export const MPAPortfolioResourceARNPrefix = 'arn:aws-proserve:mpa:us-west-2:portfolio:';

/**
 * Creates an ARN for a specific MPA portfolio resource or nested resource or attribute
 * @param portfolioResourceStr represent an MPA portfolio resource or nested resource or attribute
 */
export function createPortfolioResourceARN(portfolioResourceStr: string): string {
    return `${MPAPortfolioResourceARNPrefix}${portfolioResourceStr}`;
}

/**
 * Gets the MPA portfolio resource identifier from an MPA portfolio resource ARN
 * @param arn The ARN to parse
 */
export function parsePortfolioResourceARN(arn: string): string {
    const index = arn.indexOf(MPAPortfolioResourceARNPrefix);
    if (index < 0) {
        throw new Error(`${arn} is not a valid MPA Portfolio Resource ARN, valid ARNs must start with ${MPAPortfolioResourceARNPrefix}`);
    }
    return arn.slice(MPAPortfolioResourceARNPrefix.length);
}

export const getId = (references: string[], resourceType: string): string | null => {
    const reference = references.find(reference => reference.includes(resourceType));
    if (reference) {
        return reference.split(':').pop() ?? null;
    } else {
        return null;
    }
};
